import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewAssessmentReportComponent } from './view-assessment-report.component';
import { ViewAssessmentReportModalComponent } from './view-assessment-report-modal.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [ViewAssessmentReportComponent, ViewAssessmentReportModalComponent],
  imports: [
    CommonModule,
    PipesModule
  ],
  entryComponents: [ViewAssessmentReportComponent, ViewAssessmentReportModalComponent],
  exports: [ViewAssessmentReportComponent, ViewAssessmentReportModalComponent]
})
export class ViewAssessmentReportModule { }
